import { useMemo } from 'react';

const useDealerOptions = ({ dealers, workLocations, generalData, userInfo }) => {
  const dealerOptions = useMemo(
    () =>
      dealers.some(x => x.id === generalData.userPartnerId)
        ? dealers
        : [...dealers, { id: generalData.userPartnerId, name: generalData.userPartnerName }],
    [dealers, generalData.userPartnerId, generalData.userPartnerName]
  );

  const workLocationOptions = useMemo(
    () =>
      workLocations.some(x => x.id === userInfo.userExtraInfoModel.userDeliveryPartnerAddressId)
        ? workLocations
        : [
            ...workLocations,
            ...(userInfo.userExtraInfoModel.userDeliveryPartnerAddressId !== null
              ? [
                  {
                    id: userInfo.userExtraInfoModel.userDeliveryPartnerAddressId,
                    name: userInfo.userExtraInfoModel.userDeliveryPartnerAddressName
                  }
                ]
              : [])
          ],
    [workLocations, userInfo.userExtraInfoModel.userDeliveryPartnerAddressId, userInfo.userExtraInfoModel.userDeliveryPartnerAddressName]
  );

  return { dealerOptions, workLocationOptions };
};

export default useDealerOptions;
